module.exports = __webpack_public_path__ + "static/img/xjDriver.f43cba1f.png";